import React from "react"
import styled from "styled-components"
import breakpoints from "../../styles/breakpoints"
import colors from "../../styles/colors"
import fonts from "../../styles/fonts"

const IntroContainer = styled.div`
  padding: 24px 16px 20px;
  display: flex;
  flex-direction: column;
  gap: 18px;

  @media (min-width: ${breakpoints.md}) {
    padding: 24px 32px 5px;
  }

  @media (min-width: ${breakpoints.lg}) {
    padding: 46px 46px 17px 0;
    flex-direction: row;
    justify-content: space-between;
    gap: 32px;
  }
`

const Title = styled.div`
  ${fonts.ivyPrestoLight};
  font-size: 20px;
  line-height: 1.3;
  color: ${colors.trueBlack};
  border-bottom: 1px solid #ccc;
  padding-bottom: 16px;

  @media (min-width: ${breakpoints.md}) {
    font-size: 45px;
  }

  @media (min-width: ${breakpoints.lg}) {
    padding-bottom: 0;
    border-bottom: none;
    flex: 1;
    max-width: 58%;
    font-size: 45px;
  }
`

const Description = styled.h1`
  ${fonts.ivyStyleLight};
  font-size: 12px;
  line-height: 1.3;
  color: ${colors.trueBlack};
  max-width: 448px;

  @media (min-width: ${breakpoints.md}) {
    font-size: 14px;
  }

  @media (min-width: ${breakpoints.lg}) {
    flex: 1;
    text-align: right;
    margin-top: 16px;
    width: 42%;
  }
`

const Intro = ({ collectionName, pageTitle }) => {
  return (
    <IntroContainer>
      <Title>{collectionName}</Title>
      <Description>{pageTitle}</Description>
    </IntroContainer>
  )
}

export default Intro
